import { FC, useState } from "react";
import PartnersBadge from "./PartnersBadge";
import { Carousel } from "react-responsive-carousel";
import Chevron from "public/icons/chevron-thick-right.svg";
import Image from "next/image";

const Testimonials: FC = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const onPreviousButtonClick = () => {
    setActiveIndex((currentIndex) => {
      const updatedIndex = (currentIndex - 1) % 2;
      return updatedIndex === -1 ? 2 - 1 : updatedIndex;
    });
  };

  const onNextButtonClick = () => {
    setActiveIndex((currentIndex) => (currentIndex + 1) % 2);
  };
  return (
    <div className="flex flex-row relative justify-center overflow-hidden w-full">
      <div className="ove">
        <div className="absolute hidden right-7 top-6 md:top-48 lg:top-20 md:-right-24 md:inline-block">
          <Image
            src="/intermediaries/left-bg-testimonials.svg"
            alt="doodle"
            width={400}
            height={121}
          />
        </div>
        <div className="absolute hidden left-4 md:top-1/2 md:-left-24 md:inline-block">
          <Image
            src="/intermediaries/right-bg-testimonials.svg"
            alt="doodle"
            width={284}
            height={125}
          />
        </div>
        <div className="hidden md:inline-block md:w-16 xl:w-32 absolute md:top-10 xl:top-40 md:-left-2 xl:left-5 z-10 bg-landing-orange h-[2px]" />
        <div className="hidden md:inline-block  md:w-12 xl:w-56 absolute  md:top-14 xl:top-48 md:-left-6   xl:-left-40 bg-landing-orange h-[2px]" />
        <div className="hidden md:inline-block w-52 absolute bottom-60 right-0 bg-landing-orange h-[2px]" />
        <div className="hidden md:inline-block w-28 absolute bottom-52 right-14 bg-landing-orange h-[2px]" />
      </div>
      <div className="w-full lg:w-4/5">
        {/* <Carousel
          showIndicators={false}
          showStatus={false}
          showArrows={false}
          showThumbs={false}
          swipeable={false}
          selectedItem={activeIndex}
          axis="horizontal"
        > */}
        <div className="flex flex-col relative items-center my-24 md:my-14 lg:my-36 mx-7 md:mx-14 lg:mx-auto">
          <h2 className="mb-9 text-4xl font-bold text-center md:text-5xl">
            “A pleasure to work with”
          </h2>
          <p className="font-serif w-4/5 lg:w-[46rem] mb-16 text-xl md:w-2/3 text-center font-normal xl:text-2xl">
            “It was refreshing to work along side the team, who worked alongside me to get the sale
            over the line”
          </p>
          <PartnersBadge />
        </div>

        {/* <div className="flex flex-col relative items-center my-24 md:my-14 lg:my-36 mx-7 md:mx-14 lg:mx-auto">
            <h2 className="mb-9 text-4xl font-bold text-center md:text-5xl">
              “Keyzy set up my path”
            </h2>
            <p className="font-serif w-4/5 lg:w-[46rem] mb-16 text-xl md:w-2/3 text-center font-normal xl:text-2xl">
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam at justo id ex
              sollicitudin varius eget eget mi.”
            </p>
            <Chevron
              className="absolute z-50 w-3 rotate-180 left-2 md:left-9 top-40 md:top-24 absolute-center-y"
              onClick={onPreviousButtonClick}
            />
            <Chevron
              className="absolute z-50 w-3 right-2 md:right-9 top-40 md:top-24 absolute-center-y"
              onClick={onNextButtonClick}
            />
            <PartnersBadge />
          </div> */}
        {/* </Carousel> */}
      </div>
    </div>
  );
};

export default Testimonials;
